<template>
  <div class="image-component" v-bind:style="background_image">
    <div class="image-component-overlay" v-bind:class="overlay_class"></div>
  </div>
</template>

<script>
  export default {
    props: ['image'],
    data () {
      return {
        background_image: '',
        overlay_class: ''
      }
    },
    methods: {
      load_image () {
        var context = this
        var downloadingImage = new Image()
        downloadingImage.onload = () => {
          context.background_image = { "background-image" : "url('" + context.image + "')" }
          setTimeout(() => {
            context.overlay_class = 'overlay-finished'
          })
        }
        downloadingImage.src = this.image
      }
    },
    mounted () {
      this.load_image()
    }
  }
</script>

<style scoped lang="scss">

  @import '../../styles/variables';

  .image-component, .image-component-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .image-component {
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  }

  .image-component-overlay {
    background: $white-solid;
    transition: opacity $transition-1;
    &.overlay-finished {
      opacity: 0;
      pointer-events: none;
    }
  }

</style>



// WEBPACK FOOTER //
// image_component.vue?3b0d110d